import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/** Partner/MD governance view (Stage 12). Server caches 5 min — match it. */
export function useCase360Governance(enabled = true) {
  return useQuery({
    queryKey: dashboardQueryKeys.case360Governance(),
    queryFn: () => dashboardApi.getCase360Governance(),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
